import { getDialogHooks } from 'utilities/dialog-context/dialog-context-helpers';
import {
  ChangeLogDialog,
  ChangeLogDialogCallbackInput,
  ChangeLogDialogUniqueProps,
} from '../change-log-dialog';

const { useDialogForContext, useDialog: useChangeLogDialog } = getDialogHooks<
  ChangeLogDialogUniqueProps,
  ChangeLogDialogCallbackInput
>(ChangeLogDialog);
export const useChangeLogDialogForContext = useDialogForContext;
export default useChangeLogDialog;
